import React, { useContext } from "react";
import { Spin } from "antd";
import { UserContext } from "../../engine/context/User.context";

export const LoadingIndex = ({ children }) => {
  const { isConnected, appReady } = useContext(UserContext);

  if (!appReady) {
    return (
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100vh", // set height to 100vh for full viewport height
          display: "flex",
          justifyContent: "center", // center horizontally
          alignItems: "center", // center vertically
        }}
      >
        <Spin size={"large"} />
      </div>
    );
  } else {
    return children;
  }
};
